import { useState, useEffect } from "react";

export const useNavigation = () => {
	useEffect(() => {
		document.addEventListener("keydown", onKeyDown);
		setNavigation(0);

		return () => document.removeEventListener("keydown", onKeyDown);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const [current, setCurrent] = useState({ type: null, index: null });

	const getAllElements = () => document.querySelectorAll("button");

	const getTheIndexOfTheSelectedElement = () => {
		const element = document.querySelector(":focus");
		return element ? parseInt(element.getAttribute("nav-index")) : 0;
	};

	const setNavigation = (index) =>
		selectElement(getAllElements()[index] || document.body);

	const onKeyDown = (evt) => {
		if (evt.key !== "ArrowUp" && evt.key !== "ArrowDown" && evt.key !== "Enter")
			return;

		const allElements = getAllElements();
		const currentIndex = getTheIndexOfTheSelectedElement();

		let setIndex;
		switch (evt.key) {
			case "ArrowDown":
				const goToFirstElement = currentIndex + 1 > allElements.length - 1;
				setIndex = goToFirstElement ? 0 : currentIndex + 1;
				return selectElement(allElements[setIndex] || allElements[0], setIndex);
			case "ArrowUp":
				const goToLastElement = currentIndex === 0;
				setIndex = goToLastElement ? allElements.length - 1 : currentIndex - 1;
				return selectElement(allElements[setIndex] || allElements[0], setIndex);
			case "Enter":
				getAllElements()[currentIndex].click();
				return false;
			default:
				break;
		}
	};

	const selectElement = (selectElement, setIndex = 0) => {
		if (selectElement) {
			[].forEach.call(getAllElements(), (element, index) => {
				const selectThisElement = element === selectElement;
				element.setAttribute("nav-index", index);
				selectThisElement ? element.focus() : element.blur();
			});
			setCurrent({ type: selectElement.tagName, index: setIndex });
		} else {
			setNavigation(0);
		}
	};

	return [current, setNavigation];
};
